import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, capitalize, capitalizeWord } from './format'

export function newLabel(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_LABEL_START", payload: "" })
            
            console.log("new Label START", {data})
            const res = await axios.post('/labels/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_LABEL_ERROR", dispatch ) ) {
                res.data.label_name = capitalizeWord(res.data.label_name)
				dispatch({ type: "NEW_LABEL", payload: res.data })
				dispatch({ type: "CREATE_LABEL_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new label ", err);
            dispatch({
                type: "CREATE_LABEL_ERROR",
                payload: err
            })
        }
    }
}

export function fetchLabels() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_LABELS_START", payload: "" })

            console.log("fetch Label START")
            const res = await axios.get('/labels/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_LABELS_ERROR", dispatch ) ) {               
                let list = capitalize(orderByAsc(res.data, "label_name"), "label_name")
                dispatch({
                    type: "GET_LABELS",
                    payload: formatList(list, "label_id")
                })
                dispatch({ type: "FETCH_LABELS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get labels list ", err);
            dispatch({ type: "FETCH_LABELS_ERROR", payload: err })
        }
    }
}

export function updateLabel(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LABEL_START", payload: "" })

            console.log("update Label START")
            const res = await axios.post("/labels/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LABEL_ERROR", dispatch ) ) {               
                data.label_name = capitalizeWord(data.label_name)
				dispatch({
                    type: "UPDATE_LABEL",
                    payload: data
                })
				dispatch({ type: "UPDATE_LABEL_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update label ", err);
            dispatch({
                type: "UPDATE_LABEL_ERROR",
                payload: err
                
            })
        }
    }
}
